"use strict";

module.exports = function () {
  this.data.forEach(function (row, index) {
    this.opts.dateColumns.forEach(function (column) {
      row[column] = moment(row[column], this.opts.toMomentFormat);
    }.bind(this));
  }.bind(this));
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/transform-date-strings-to-moment.js
// module id = 2219
// module chunks = 1